// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery-section {
  position: relative;
  scroll-margin-top: 4.5rem;
  background: var(--bg-page);
  border-bottom: 1px solid var(--border-subtle);
}

.gallery-section__inner {
  max-width: 900px;
  margin: 0 auto;
  padding: 4.5rem 1.25rem;
}

.gallery-section__intro {
  text-align: center;
  max-width: 56ch;
  margin: 0 auto 3rem;
}

.gallery-section__eyebrow {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--interactive-hover);
  margin-bottom: 0.75rem;
}

.gallery-section__title {
  font-size: clamp(1.5rem, 3vw, 2.1rem);
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.6rem;
}

.gallery-section__subtitle {
  color: var(--text-secondary);
  font-size: 1rem;
  line-height: 1.6;
}

.gallery-section__empty {
  text-align: center;
  color: var(--text-muted);
  font-size: 1rem;
}

/* ---------- Category carousels, stacked ---------- */

.gallery-categories {
  display: grid;
  gap: 3rem;
}

.gallery-category__heading {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.gallery-category__index {
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--interactive-hover);
}

.gallery-category__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
}

/* ---------- CTA ---------- */

.gallery-section__cta {
  display: flex;
  justify-content: center;
  margin-top: 3.5rem;
}

@media (max-width: 640px) {
  .gallery-section__inner {
    padding: 3rem 1rem;
  }

  .gallery-section__intro {
    margin-bottom: 2.25rem;
  }

  .gallery-categories {
    gap: 2.25rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/shared/components/GallerySection/GallerySection.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,sDAAsD;;AAEtD;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,8BAA8B;;AAE9B;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".gallery-section {\n  position: relative;\n  scroll-margin-top: 4.5rem;\n  background: var(--bg-page);\n  border-bottom: 1px solid var(--border-subtle);\n}\n\n.gallery-section__inner {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 4.5rem 1.25rem;\n}\n\n.gallery-section__intro {\n  text-align: center;\n  max-width: 56ch;\n  margin: 0 auto 3rem;\n}\n\n.gallery-section__eyebrow {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  color: var(--interactive-hover);\n  margin-bottom: 0.75rem;\n}\n\n.gallery-section__title {\n  font-size: clamp(1.5rem, 3vw, 2.1rem);\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.6rem;\n}\n\n.gallery-section__subtitle {\n  color: var(--text-secondary);\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n.gallery-section__empty {\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 1rem;\n}\n\n/* ---------- Category carousels, stacked ---------- */\n\n.gallery-categories {\n  display: grid;\n  gap: 3rem;\n}\n\n.gallery-category__heading {\n  display: flex;\n  align-items: baseline;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.gallery-category__index {\n  font-size: 0.85rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--interactive-hover);\n}\n\n.gallery-category__title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n/* ---------- CTA ---------- */\n\n.gallery-section__cta {\n  display: flex;\n  justify-content: center;\n  margin-top: 3.5rem;\n}\n\n@media (max-width: 640px) {\n  .gallery-section__inner {\n    padding: 3rem 1rem;\n  }\n\n  .gallery-section__intro {\n    margin-bottom: 2.25rem;\n  }\n\n  .gallery-categories {\n    gap: 2.25rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
